export class Solicitacao {

  private associado:  number;
  private usuario:    number;
  private id:         number;
  private tipo:       string;
  private titulo:     string;
  private descricao:  string;
  private status:     string;
  private relevancia: number;

  public toJSON() {
    return {
      associado:  this.associado,
      usuario:    this.usuario,
      id:         this.id,
      tipo:       this.tipo,
      titulo:     this.titulo,
      descricao:  this.descricao,
      status:     this.status,
      relevancia: this.relevancia
    };
  }

  public toClass(associado) {
    this.associado  = associado.associado;
    this.usuario    = associado.usuario;
    this.id         = associado.id;
    this.tipo       = associado.tipo;
    this.titulo     = associado.titulo;
    this.descricao  = associado.descricao;
    this.status     = associado.status;
    this.relevancia = associado.relevancia;
  }

}
